import { SelectSort, SwitchGridList } from '../../../shared/ui';
import { useView, useSort, useFilterPages } from '../hooks';
import { SORT_ITEMS, FILTER_PAGE_ITEMS } from '../config';

export const WorkspaceFilters = () => {
  const { view, setView } = useView();
  const { sort, setSort } = useSort();
  const { filter, setFilter } = useFilterPages();

  return (
    <div className="md:flex-grow-1 flex flex-nowrap gap-x-3">
      <SelectSort
        value={filter}
        onChange={(value) => setFilter(value)}
        items={FILTER_PAGE_ITEMS}
        className="md:hidden"
      />
      <SelectSort
        value={sort}
        onChange={(value) => setSort(value)}
        items={SORT_ITEMS}
        className="md:w-full"
      />
      <SwitchGridList
        value={view}
        onChange={(value) => setView(value)}
        className="lg:hidden"
      />
    </div>
  );
};
